import { createContext } from 'react'

import { BadgeTotalContextType } from './BadgeTotalContextType'

export const BadgeTotalContext = createContext<BadgeTotalContextType | undefined>(undefined)
